<template>
	<div class="p-col-12 p-grid">

		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeAgent6ImageUrl()" alt="" style="width: 80%; margin: auto">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>SECURE</p>
			<p class="login-subtitle">Choose Your Path with Our Agent Program</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Are you an agent looking to take your career to the next level? Our Agent Program offers two paths to success:</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Collaborate with our platform: Work with us to manage your profiles, and we'll handle all the details, while you benefit from free access and increased exposure.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Affiliate with us: Join our network for a small annual fee and manage your profiles independently, with the support of our powerful tools and resources.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Choose the path that fits your needs and reach new heights with our Agent Program.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Choose TiroLibre's Agent Program to advance your career. </p>
			<p v-if="commonService.isMobile()" class="login-text justified">Collaborate with us for free access and exposure for your clients, or affiliate with us for a small annual fee and manage your profiles independently with our tools and resources.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-5 button-box' : 'p-lg-3 button-box'" style="padding: 0px">
				<Button label="Build your portfolio" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeAgent6ImageUrl()" alt="" style="width: 90%; margin: auto">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-6 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Build your portfolio" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>